import { useMemo } from 'react'
import { useModules } from '@hooks/useModules'
import {
  CourseModuleSection,
  CourseModulesWrapper,
  filterAvailableModules,
} from './CourseModuleSection'

export function CourseModules() {
  const { modules, onLoadMore, onLoadMoreSubmodules, hasMoreSubmodules } =
    useModules()

  const filteredAvailableModules = useMemo(() => {
    if (!modules) return []
    return filterAvailableModules(modules.nodes)
  }, [modules])

  if (!modules) return null
  return (
    <CourseModulesWrapper id="course-modules">
      {filteredAvailableModules.map((module, index) => {
        const hasMoreModules = index !== filteredAvailableModules.length - 1

        // Decidir por `availableSubmodules` (lista filtrada) matava a paginação
        // assim que um submódulo era escondido — o tamanho da página vale para
        // a lista buscada, não para a exibida.
        const canLoadMoreSubmodules = hasMoreSubmodules?.(module) ?? false

        return (
          <CourseModuleSection
            key={module.id}
            module={module}
            index={index}
            isLastModuleOfData={hasMoreModules}
            onLoadMore={onLoadMore}
            canLoadMoreSubmodules={canLoadMoreSubmodules}
            onLoadMoreSubmodules={
              onLoadMoreSubmodules
                ? () => onLoadMoreSubmodules(module.id)
                : undefined
            }
          />
        )
      })}
    </CourseModulesWrapper>
  )
}
